<template>
    <div>
        <img :src="imgDataUrl"/>
        <div v-if="is_me" class="edit-avatar d-flex justify-content-center align-items-center">
            <i class="fa fa-camera-retro"></i>
            <label class="fileContainer" @click="toggleShow">
                {{word.edit_avatar}}
            </label>
        </div>
        <my-upload
            v-if="show"
            field="img"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="show"
            :width="200"
            :height="200"
            :url="'/en/upload/avatar'"
            :params="params"
            :headers="headers"
            img-format="png"
            langType="en"
            :noRotate="false"
            :noSquare="false"
            :noCircle="false"
        ></my-upload>
    </div>
</template>

<script>
    import myUpload from "vue-image-crop-upload";
    import Events from "../../../front/events";

    export default {
        components: {
            "my-upload": myUpload
        },
        props: {
            avatar_url: {
                type: String,
                required: true
            },
            container_class: {
                type: String
            },
            container_style: {
                type: String
            },
            image_class: {
                type: String
            },
            image_style: {
                type: String
            },
            is_me: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                show: false,
                params: {
                    token: "123456798",
                    name: "avatar"
                },
                headers: {
                    smail: "*_~",
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                imgDataUrl: this.avatar_url, // the datebase64 url of created image
                text: window.text,
                word: window.word
            };
        },
        methods: {
            toggleShow() {
                this.show = !this.show;
            },
            /**
             * crop success
             *
             * [param] imgDataUrl
             * [param] field
             */
            cropSuccess(imgDataUrl, field) {
                console.log("-------- crop success --------");
                this.imgDataUrl = imgDataUrl;
            },
            /**
             * upload success
             *
             * [param] jsonData  server api return data, already json encode
             * [param] field
             */
            cropUploadSuccess(jsonData, field) {
                console.log("-------- upload success --------");
                console.log(jsonData);
                if (jsonData.ok == true) {
                    this.$toast.success(jsonData.msg);
                }
                console.log("field: " + field);
                let self = this;
                setTimeout(function () {
                    self.show = false;
                }, 1000);

                refreshUser()
            },
            /**
             * upload fail
             *
             * [param] status    server api return error status, like 500
             * [param] field
             */
            cropUploadFail(status, field) {
                console.log("-------- upload fail --------");
                console.log(status);
                console.log("field: " + field);
                setTimeout(function () {
                    self.show = false;
                }, 1000);
            }
        }
    };
</script>
